import type { ContextMenuConfig } from '@milanote/roma';
import type { ElementContextMenuContext, MobileElementContextMenuActions } from '../context/elementContextMenuContext';
import { ELEMENT_CONTEXT_MENU_ITEMS, getSelectedElementDetailItems } from '../items/elementContextMenuItems';
import { elementMetadataMenuItems } from '../items/elementMetadataMenuItems';

const items = ELEMENT_CONTEXT_MENU_ITEMS;

// Ordered as: standard edit controls, then element-specific actions, then generic element actions.
export const elementDesktopMenuConfig: ContextMenuConfig<ElementContextMenuContext> = [
    {
        id: 'clipboard',
        items: [
            items.paste,
            items.cut,
            items.copy,
            items.pasteStyles,
            items.duplicateAlias,
            items.duplicate,
            items.duplicateLinkedBoard,
            items.clone,
            items.moveToTrash,
        ],
    },
    { id: 'naming', items: [items.rename] },
    {
        id: 'board',
        items: [
            items.openInNewTab,
            items.findOriginalBoard,
            items.createShortcut,
            items.copyBoardLink,
            items.convertToTemplate,
            items.revertTemplateToBoard,
        ],
    },
    {
        id: 'media',
        items: [
            items.downloadOriginal,
            items.openFile,
            items.replaceImage,
            items.addImage,
            items.copyLink,
            items.imageAspectRatio,
        ],
    },
    { id: 'drawing-download', items: [items.downloadSvg] },
    { id: 'grouping', items: [items.groupIntoColumn, items.connectWithLines] },
    { id: 'sketch-conversion', items: [items.convertToSketch] },
    {
        id: 'conversion',
        items: [items.convertToNote, items.convertToDocument, items.convertColumnToBoard],
    },
    { id: 'lock', items: [items.toggleLock] },
    { id: 'arrangement', items: [items.bringToFront, items.sendToBack] },
    { id: 'development', items: getSelectedElementDetailItems },
    { id: 'metadata', items: elementMetadataMenuItems },
];

const DESKTOP_TOOLBAR_EXCLUDED_SECTIONS = new Set(['clipboard', 'naming']);
const TABLET_TOOLBAR_EXCLUDED_SECTIONS = new Set(['naming']);

/** Removes actions already available directly from the desktop toolbar. */
export const elementDesktopToolbarMenuConfig = elementDesktopMenuConfig.filter(
    ({ id }) => !DESKTOP_TOOLBAR_EXCLUDED_SECTIONS.has(id),
);

/** Removes actions already available directly from the tablet toolbar. */
export const elementTabletToolbarMenuConfig = elementDesktopMenuConfig.filter(
    ({ id }) => !TABLET_TOOLBAR_EXCLUDED_SECTIONS.has(id),
);

export const elementMobileMenuConfig: ContextMenuConfig<ElementContextMenuContext<MobileElementContextMenuActions>> = [
    {
        id: 'mobile-clipboard',
        items: [items.cut, items.copy, items.copyLink, items.duplicate, items.groupIntoColumn],
    },
    {
        id: 'mobile-board-links',
        items: [items.createShortcut, items.copyBoardLink],
    },
    {
        id: 'mobile-lock',
        items: [items.toggleLock],
    },
    {
        id: 'mobile-arrangement',
        items: [items.bringToFront, items.sendToBack],
    },
    {
        id: 'mobile-delete',
        items: [items.moveToTrash],
    },
];
